// The browser's failures reach the studio's log (server/log.ts): each kind of
// failure once a page, ten at most. Refusals the studio answered with are
// already in its log, so they are not sent again.
let sent = 0;
const seen = new Set<string>();

export function report(kind: "crash" | "error" | "rejection", cause: unknown) {
  if (typeof (cause as { status?: unknown })?.status === "number") return;
  const e =
    cause instanceof Error ? cause : new Error(String(cause ?? "unknown"));
  // A script from another origin says nothing more than this.
  if (e.message === "Script error.") return;
  const key = `${kind}:${e.message}`;
  if (seen.has(key) || sent >= 10) return;
  seen.add(key);
  sent++;
  void fetch("/api/client-errors", {
    method: "POST",
    keepalive: true,
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      kind,
      message: e.message.slice(0, 1000),
      stack: e.stack?.slice(0, 4000),
      path: window.location.pathname.slice(0, 300),
    }),
  }).catch(() => {});
}

export function watchErrors() {
  window.addEventListener("error", (e) =>
    report("error", e.error ?? e.message),
  );
  window.addEventListener("unhandledrejection", (e) =>
    report("rejection", e.reason),
  );
}
